<template>
    <div class="report__page">
        <div class="asset_list">
            <h2>Filter Options</h2>
            <div id="asset_filters">
                <div>
                    <span>Name</span>
                    <!-- <InputText v-model="AssetFilters.name" placeholder="Search Name, Category, Make or Model" /> -->
                    <MultiSelect ref="nameMultiSelect" v-model="AssetFilters.name" :options="filterOptions.name" display="chip" filter placeholder="Select Name" class="p-column-filter select_filter" :disabled="filterOptions.name ? false : true" @show="triggerLabel()" @change="triggerChip()">
                    </MultiSelect>
                </div>
                <div class="select_filter">
                    <span>Category</span>
                    <MultiSelect ref="categoryMultiSelect" v-model="AssetFilters.category" :options="filterOptions.category" display="chip" filter placeholder="Select Category" class="p-column-filter select_filter" :disabled="filterOptions.category ? false : true" @show="triggerLabel()" @change="triggerChip()">
                    </MultiSelect>
                </div>
                <div class="select_filter">
                    <span>Sub-Area</span>
                    <MultiSelect v-model="AssetFilters.location" :options="filterOptions.location" display="chip" filter placeholder="Select Sub-Area" class="p-column-filter select_filter" :disabled="filterOptions.location ? false : true" @show="triggerLabel()" @change="triggerChip()">
                    </MultiSelect>
                </div>
                <div class="select_filter">
                    <span>Area</span>
                    <MultiSelect v-model="AssetFilters.area" :options="filterOptions.area" display="chip" filter placeholder="Select Area" class="p-column-filter select_filter" :disabled="filterOptions.area ? false : true" @show="triggerLabel()" @change="triggerChip()">
                    </MultiSelect>
                </div>
                <div class="select_filter">
                    <span>Make</span>
                    <MultiSelect v-model="AssetFilters.make" :options="filterOptions.make" display="chip" filter placeholder="Select Make" class="p-column-filter select_filter" :disabled="filterOptions.make ? false : true" @show="triggerLabel()" @change="triggerChip()">
                    </MultiSelect>
                </div>
                <div class="select_filter">
                    <span>Model</span>
                    <MultiSelect v-model="AssetFilters.model" :options="filterOptions.model" display="chip" filter placeholder="Select Model" class="p-column-filter select_filter" :disabled="filterOptions.model ? false : true" @show="triggerLabel()" @change="triggerChip()">
                    </MultiSelect>
                </div>
                <div class="select_filter select_filter--date">
                    <span>Install Date</span>
                    <div>
                        <i class="pi pi-calendar-plus" style="font-size: 16px"></i>
                        <Calendar @hide="triggerClose(installDatePreParse, 'install_date')" v-model="installDatePreParse" :manualInput="false" selectionMode="range" placeholder="Select Date Range" dateFormat="d M yy" style="flex-grow: 1;" />
                    </div>
                </div>
                <div class="select_filter select_filter--date">
                    <span>Lifecycle Expiry Date</span>
                    <div>
                        <i class="pi pi-calendar-plus" style="font-size: 16px"></i>
                        <Calendar @hide="triggerClose(lifecycleDatePreParse, 'lifecycle_expiry_date')" v-model="lifecycleDatePreParse" :manualInput="false" selectionMode="range" placeholder="Select Date Range" dateFormat="d M yy" style="flex-grow: 1;" />
                    </div>
                </div>
                <div class="select_filter">
                    <span>Lifecycle Status</span>
                    <MultiSelect v-model="AssetFilters.lifecycle_status" :options="filterOptions.lifecycle_status" display="chip" filter placeholder="Select Status" class="p-column-filter select_filter" :disabled="filterOptions.lifecycle_status ? false : true" @show="triggerLabel()" @change="triggerChip()">
                    </MultiSelect>
                </div>
                <div class="select_filter select_filter--date">
                    <span>Last Maintained Date</span>
                    <div>
                        <i class="pi pi-calendar-plus" style="font-size: 16px"></i>
                        <Calendar @hide="triggerClose(maintainanceDatePreParse, 'last_maintained_date')" v-model="maintainanceDatePreParse" :manualInput="false" selectionMode="range" placeholder="Select Date Range" dateFormat="d M yy" style="flex-grow: 1;" />
                    </div>
                </div>
                <div class="select_filter select_filter--date">
                    <span>Maintenance Schedule Start Date</span>
                    <div>
                        <i class="pi pi-calendar-plus" style="font-size: 16px"></i>
                        <Calendar @hide="triggerClose(maintenanceScheduleStartDatePreParse, 'maintenance_schedule_start_date')" v-model="maintenanceScheduleStartDatePreParse" :manualInput="false" selectionMode="range" placeholder="Select Date Range" dateFormat="d M yy" style="flex-grow: 1;" />
                    </div>
                </div>
                <div class="select_filter">
                    <span>Maintenance / Attendance Status</span>
                    <MultiSelect ref="maintenanceMultiSelect" v-model="AssetFilters.maintenance_status" :options="filterOptions.maintenance_status" display="chip" filter placeholder="Select Status" class="p-column-filter select_filter" :disabled="filterOptions.maintenance_status ? false : true" @show="triggerLabel()" @change="triggerChip()">
                    </MultiSelect>
                </div>
                <div class="select_filter">
                    <span>Last Report</span>
                    <MultiSelect v-model="AssetFilters.maintenance_current_status" :options="filterOptions.maintenance_current_status" display="chip" filter placeholder="Select Result" class="p-column-filter select_filter" :disabled="filterOptions.maintenance_current_status ? false : true" @show="triggerLabel()" @change="triggerChip()">
                    </MultiSelect>
                </div>
                <div class="select_filter select_filter--date">
                    <span>Warranty Expiry Date</span>
                    <div>
                        <i class="pi pi-calendar-plus" style="font-size: 16px"></i>
                        <Calendar @hide="triggerClose(warrantyDatePreParse, 'warranty_expiry_date')" v-model="warrantyDatePreParse" :manualInput="false" selectionMode="range" placeholder="Select Date Range" dateFormat="d M yy" style="flex-grow: 1;" />
                    </div>
                </div>
                <div class="select_filter">
                    <span>Warranty Status</span>
                    <MultiSelect v-model="AssetFilters.warranty_status" :options="filterOptions.warranty_status" display="chip" filter placeholder="Select Status" :disabled="filterOptions.warranty_status ? false : true" @show="triggerLabel()" @change="triggerChip()" class="p-column-filter select_filter">
                    </MultiSelect>
                </div>
                <div class="select_filter">
                    <span>Fault Status</span>
                    <MultiSelect v-model="AssetFilters.fault_status" :options="filterOptions.fault_status" display="chip" filter placeholder="Select Status" :disabled="filterOptions.fault_status ? false : true" @show="triggerLabel()" @change="triggerChip()" class="p-column-filter select_filter">
                    </MultiSelect>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { db } from '@/firebase.js'

export default {
    data() {
        return {
            filterOptions: [],
            warrantyWarningoptions: [
                { label: '1 Week', value: 604800 },
                { label: '1 Month', value: 2630000 },
                { label: '3 Months', value: 7890000 },
                { label: '6 Months', value: 15780000 },
                { label: '1 Year', value: 31560000 }
            ],
            maintenanceFrequencyoptions: [
                { label: 'Daily', value: 86400, threshold: 10800 }, // 10800 = 3 hours for a 2 hour threshold
                { label: 'Weekly', value: 604800, threshold: 172800 },
                { label: 'Monthly', value: 2630000, threshold: 604800 },
                { label: 'Quarterly', value: 7890000, threshold: 1209600 },
                { label: '6 Monthly', value: 15780000, threshold: 2630000 },
                { label: 'Annually', value: 31560000, threshold: 2630000 }
            ],
            AssetFilters: {
                // Include name property to match store structure
                name: [],
                asset_id: [],
                make: [],
                model: [],
                location: [],
                area: [],
                category: [],
                type: [],
                maintenance_status: [],
                maintenance_current_status: [],
                warranty_status: [],
                lifecycle_status: [],
                install_date: [],
                warranty_expiry_date: [],
                last_maintained_date: [],
                maintenance_schedule_start_date: [],
                lifecycle_expiry_date: [],
                fault_status: []
            },
            lifecycle_status_sender: [],
            warranty_status_sender: [],
            fault_status_sender: [],
            maintenance_status_sender: [],
            installDatePreParse: null,
            warrantyDatePreParse: null,
            lifecycleDatePreParse: null,
            maintainanceDatePreParse: null,
            maintenanceScheduleStartDatePreParse: null,
            assetValuestoCheck: [],
        }
    },

    mounted() {
        this.fetchFilters()
        
        // Get the current store value
        const storeFilters = this.$store.getters['createCustomReport/getSelectedFilterOptions']
        
        // Ensure AssetFilters is always a proper object, not an array
        this.AssetFilters = {
            name: storeFilters.name || [],
            asset_id: storeFilters.asset_id || [],
            make: storeFilters.make || [],
            model: storeFilters.model || [],
            location: storeFilters.location || [],
            area: storeFilters.area || [],
            category: storeFilters.category || [],
            type: storeFilters.type || [],
            maintenance_status: storeFilters.maintenance_status || [],
            maintenance_current_status: storeFilters.maintenance_current_status || [],
            warranty_status: storeFilters.warranty_status || [],
            lifecycle_status: storeFilters.lifecycle_status || [],
            install_date: storeFilters.install_date || [],
            warranty_expiry_date: storeFilters.warranty_expiry_date || [],
            last_maintained_date: storeFilters.last_maintained_date || [],
            lifecycle_expiry_date: storeFilters.lifecycle_expiry_date || [],
            maintenance_schedule_start_date: storeFilters.maintenance_schedule_start_date || [],
            fault_status: storeFilters.fault_status || []
        }
        
        // Parse date timestamps from store and convert to Date objects for Calendar components
        this.parseDateFromStore(storeFilters)
        
        // Force a reactive update to ensure all components reflect the store values
        this.$nextTick(() => {
            // Create new objects to trigger Vue's reactivity
            const newAssetFilters = { ...this.AssetFilters }
            this.AssetFilters = newAssetFilters
        })
        
        console.log('CustomReportPage2 - mounted AssetFilters:', this.AssetFilters)
        console.log('CustomReportPage2 - storeFilters:', storeFilters)
    },

    watch: {
        // Watch for store changes and update local state accordingly
        '$store.state.createCustomReport.selectedFilterOptions': {
            handler(newFilters) {
                console.log('CustomReportPage2 - store filters changed:', newFilters)
                
                // Update local AssetFilters
                this.AssetFilters = {
                    name: newFilters.name || [],
                    asset_id: newFilters.asset_id || [],
                    make: newFilters.make || [],
                    model: newFilters.model || [],
                    location: newFilters.location || [],
                    area: newFilters.area || [],
                    category: newFilters.category || [],
                    type: newFilters.type || [],
                    maintenance_status: newFilters.maintenance_status || [],
                    maintenance_current_status: newFilters.maintenance_current_status || [],
                    warranty_status: newFilters.warranty_status || [],
                    lifecycle_status: newFilters.lifecycle_status || [],
                    install_date: newFilters.install_date || [],
                    warranty_expiry_date: newFilters.warranty_expiry_date || [],
                    last_maintained_date: newFilters.last_maintained_date || [],
                    lifecycle_expiry_date: newFilters.lifecycle_expiry_date || [],
                    maintenance_schedule_start_date: newFilters.maintenance_schedule_start_date || [],
                    fault_status: newFilters.fault_status || []
                }
                
                // Update date pre-parse variables
                this.parseDateFromStore(newFilters)
            },
            deep: true
        }
    },


    methods: {
        parseDateFromStore(storeFilters) {
            // Convert Unix timestamps to Date objects for Calendar components
            if (storeFilters.install_date && storeFilters.install_date.length >= 2) {
                this.installDatePreParse = [
                    new Date(storeFilters.install_date[0] * 1000),
                    new Date(storeFilters.install_date[1] * 1000)
                ]
            }
            
            if (storeFilters.warranty_expiry_date && storeFilters.warranty_expiry_date.length >= 2) {
                this.warrantyDatePreParse = [
                    new Date(storeFilters.warranty_expiry_date[0] * 1000),
                    new Date(storeFilters.warranty_expiry_date[1] * 1000)
                ]
            }
            
            if (storeFilters.lifecycle_expiry_date && storeFilters.lifecycle_expiry_date.length >= 2) {
                this.lifecycleDatePreParse = [
                    new Date(storeFilters.lifecycle_expiry_date[0] * 1000),
                    new Date(storeFilters.lifecycle_expiry_date[1] * 1000)
                ]
            }
            
            if (storeFilters.last_maintained_date && storeFilters.last_maintained_date.length >= 2) {
                this.maintainanceDatePreParse = [
                    new Date(storeFilters.last_maintained_date[0] * 1000),
                    new Date(storeFilters.last_maintained_date[1] * 1000)
                ]
            }
            
            if (storeFilters.maintenance_schedule_start_date && storeFilters.maintenance_schedule_start_date.length >= 2) {
                this.maintenanceScheduleStartDatePreParse = [
                    new Date(storeFilters.maintenance_schedule_start_date[0] * 1000),
                    new Date(storeFilters.maintenance_schedule_start_date[1] * 1000)
                ]
            }
        },

        async fetchFilters() {
            const selectedSites = this.$store.getters['createCustomReport/getSites']

            for await (const site of selectedSites) {
                const filters = await db.collection('filters').doc(site.site_id).get()
                if (filters.exists) {
                    this.filterOptions.push(filters.data())
                }
            }

            if (this.filterOptions.length > 0) {
                const consolidatedFilterItems = this.filterOptions.reduce((acc, obj) => {
                    Object.keys(obj).forEach(key => {
                        // Merge values into a set to exclude duplicates and then spread them into an array
                        acc[key] = [...new Set([...(acc[key] || []), ...obj[key]])]
                    });
                    return acc
                }, {})

                this.filterOptions = consolidatedFilterItems
            } else {
                // Set default empty arrays for all filter options if no filters exist
                this.filterOptions = {
                    name: [''],
                    asset_type: [''],
                    category: [''],
                    make: [''],
                    model: [''],
                    location: [''],
                    area: [''],
                    warranty_status: ['', 'In Warranty', 'Warning', 'Out of Warranty'],
                    maintenance_status: ['', 'OK', 'Warning', 'Overdue'],
                    lifecycle_status: ['', 'OK', 'Warning', 'Expired'],
                    maintenance_current_status: ['', 'Pass', 'Fail'],
                    fault_status: ['', 'Fault', 'In Progress', 'Rectified']
                }
            }
        },

        async checkIfExists() {

            let hasItems = true
            const assetTypes = this.$store.getters['createCustomReport/getAssetTypes'].map((type) => type.asset_type)

            if (event.target.innerText == '' || event.target.innerText == 'Unassigned') {
                // console.log('empty value')
            } else {
                for await (const filter of Object.entries(this.AssetFilters)) { // may also need to loop through site ID's later
                    if (filter[1].length) {
                        // filter[0] == key
                        // filter[1] == entry

                        for await (const filterParam of filter[1]) {
                            const assetsIncluded = await db.collection('assets')
                            .where('asset_type', 'in', assetTypes)
                            .where(filter[0], '==', filterParam)
                            .get()
                            if (assetsIncluded.empty) {
                                hasItems = false
                            }
                        }
                    }
                }
            }

            if (!hasItems) {
                this.$toast.add({ severity: 'warn', summary: 'Warning', detail: 'Please note - this filter option may not return any results for this Asset selection.', life: 5000 });
            }

            this.updateStoreFilters()
        },

        updateStoreFilters() {
            // Filter out empty arrays before dispatching
            const filteredFilters = {}
            Object.keys(this.AssetFilters).forEach(key => {
                if (this.AssetFilters[key] && this.AssetFilters[key].length > 0) {
                    filteredFilters[key] = this.AssetFilters[key]
                }
            })
            
            console.log('CustomReportPage2 - dispatching AssetFilters:', filteredFilters)
            this.$store.dispatch('createCustomReport/selectFilterOptions', filteredFilters)
            console.log('CustomReportPage2 - after dispatch:', this.$store.getters['createCustomReport/getSelectedFilterOptions'])
        },

        triggerChip() {
            this.checkIfExists()
            this.updateStoreFilters()
            let labels = document.querySelectorAll('.p-multiselect-label');

            labels.forEach((span) => {
                setTimeout(function () {
                    let tokens = span.querySelectorAll('.p-multiselect-token');
                    if (tokens.length) {
                        tokens.forEach((token) => {
                            let span = token.querySelector('.p-multiselect-token-label');
                            if (span.innerHTML == '') {
                                span.innerHTML = 'Unassigned'; // overwrites empty string
                            }
                        })
                    }
                }, 1) // timeout required due to toolkit adding chip to label
            })
        },

        triggerLabel() {
            let emptySpan = event.currentTarget.querySelector('.p-multiselect-item > span:first-of-type'); // selects first item
            emptySpan.innerHTML = 'Unassigned';
        },

        triggerClose(value, selector) {
            let array = [];
            value.forEach(function (timestamp) {
                let formattedDate = new Date(timestamp)
                timestamp = formattedDate.getTime();
                array.push(timestamp / 1000);
            });
            switch (selector) {
                case 'install_date':
                    this.AssetFilters.install_date = array;
                    break;
                case 'warranty_expiry_date':
                    this.AssetFilters.warranty_expiry_date = array;
                    break;
                case 'last_maintained_date':
                    this.AssetFilters.last_maintained_date = array;
                    break;
                case 'maintenance_schedule_start_date':
                    this.AssetFilters.maintenance_schedule_start_date = array;
                    break;
                case 'lifecycle_expiry_date':
                    this.AssetFilters.lifecycle_expiry_date = array;
                    break;
                default:
            }

            this.checkIfExists()
            this.updateStoreFilters()
        },
    }
}
</script>

<style lang="scss" scoped>
.report__page {
    height: 100%;

    .asset_list {
        padding: .5rem;

        h2 {
            padding-left: 1rem;
            margin: 0;
        }

        #asset_filters {
            background-color: white !important;
        }

    }
}
</style>